var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Transaction, } from '@solana/web3.js';
import log from 'loglevel';
import { sleep } from './common';
export var DEFAULT_TIMEOUT = 15000;
export var getUnixTs = function () {
    return new Date().getTime() / 1000;
};
export var envFor = function (connection) {
    var endpoint = connection._rpcEndpoint;
    var regex = /https:\/\/api.([^.]*).solana.com/;
    var match = endpoint.match(regex);
    if (match && match[1]) {
        return match[1];
    }
    return 'mainnet-beta';
};
export var explorerLinkFor = function (txid, connection) {
    return "https://explorer.solana.com/tx/".concat(txid, "?cluster=").concat(envFor(connection));
};
export var sendTransactionWithRetryWithKeypair = function (connection, wallet, instructions, signers, commitment, includesFeePayer, block, beforeSend) {
    if (commitment === void 0) { commitment = 'singleGossip'; }
    if (includesFeePayer === void 0) { includesFeePayer = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var transaction, _a, _b, _c, txid, slot;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    transaction = new Transaction();
                    instructions.forEach(function (instruction) { return transaction.add(instruction); });
                    _a = transaction;
                    _b = block;
                    if (_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, connection.getLatestBlockhash(commitment)];
                case 1:
                    _b = (_d.sent());
                    _d.label = 2;
                case 2:
                    _a.recentBlockhash = (_b).blockhash;
                    if (includesFeePayer) {
                        transaction.setSigners.apply(transaction, __spreadArray([], __read(signers.map(function (s) { return s.publicKey; })), false));
                    }
                    else {
                        transaction.setSigners.apply(transaction, __spreadArray([
                            // fee payed by the wallet owner
                            wallet.publicKey], __read(signers.map(function (s) { return s.publicKey; })), false));
                    }
                    if (signers.length > 0) {
                        transaction.sign.apply(transaction, __spreadArray([], __read(__spreadArray([wallet], __read(signers), false)), false));
                    }
                    else {
                        transaction.sign(wallet);
                    }
                    if (beforeSend) {
                        beforeSend();
                    }
                    return [4 /*yield*/, sendSignedTransaction({
                            connection: connection,
                            signedTransaction: transaction,
                        })];
                case 3:
                    _c = _d.sent(), txid = _c.txid, slot = _c.slot;
                    return [2 /*return*/, { txid: txid, slot: slot }];
            }
        });
    });
};
export function sendSignedTransaction(_a) {
    var _b;
    var signedTransaction = _a.signedTransaction, connection = _a.connection, blockhash = _a.blockhash, lastValidBlockHeight = _a.lastValidBlockHeight;
    return __awaiter(this, void 0, Promise, function () {
        var rawTransaction, txid, confirmation, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    rawTransaction = signedTransaction.serialize();
                    return [4 /*yield*/, connection.sendRawTransaction(rawTransaction, {
                            skipPreflight: false,
                            preflightCommitment: 'confirmed',
                            maxRetries: 5,
                        })];
                case 1:
                    txid = _d.sent();
                    log.debug('Sent transaction, awaiting confirmation', txid);
                    if (!(blockhash && lastValidBlockHeight !== undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, connection.confirmTransaction({ signature: txid, blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight }, 'confirmed')];
                case 2:
                    _c = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, connection.confirmTransaction(txid, 'confirmed')];
                case 4:
                    _c = _d.sent();
                    _d.label = 5;
                case 5:
                    confirmation = _c;
                    if (confirmation.value.err) {
                        throw new Error('Transaction failed: ' + JSON.stringify(confirmation.value.err));
                    }
                    return [2 /*return*/, { txid: txid, slot: ((_b = confirmation.context) === null || _b === void 0 ? void 0 : _b.slot) || 0 }];
            }
        });
    });
}
function simulateTransaction(connection, transaction) {
    return __awaiter(this, void 0, Promise, function () {
        var message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = transaction.compileMessage();
                    return [4 /*yield*/, connection.simulateTransaction(message)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function awaitTransactionSignatureConfirmation(txid, timeout, connection, commitment, queryStatus) {
    if (commitment === void 0) { commitment = 'recent'; }
    if (queryStatus === void 0) { queryStatus = false; }
    return __awaiter(this, void 0, Promise, function () {
        var done, status, subId;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    done = false;
                    status = {
                        slot: 0,
                        confirmations: 0,
                        err: null,
                    };
                    subId = 0;
                    return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        setTimeout(function () {
                                            if (done) {
                                                return;
                                            }
                                            done = true;
                                            log.warn('Rejecting for timeout...');
                                            reject({ timeout: true });
                                        }, timeout);
                                        try {
                                            subId = connection.onSignature(txid, function (result, context) {
                                                done = true;
                                                status = {
                                                    err: result.err,
                                                    slot: context.slot,
                                                    confirmations: 0,
                                                };
                                                if (result.err) {
                                                    log.warn('Rejected via websocket', result.err);
                                                    reject(status);
                                                }
                                                else {
                                                    log.debug('Resolved via websocket', result);
                                                    resolve(status);
                                                }
                                            }, commitment);
                                        }
                                        catch (e) {
                                            done = true;
                                            log.error('WS error in setup', txid, e);
                                        }
                                        _a.label = 1;
                                    case 1:
                                        if (!(!done && queryStatus)) return [3 /*break*/, 3];
                                        // eslint-disable-next-line no-loop-func
                                        (function () { return __awaiter(_this, void 0, void 0, function () {
                                            var signatureStatuses, e_1;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        _a.trys.push([0, 2, , 3]);
                                                        return [4 /*yield*/, connection.getSignatureStatuses([
                                                                txid,
                                                            ])];
                                                    case 1:
                                                        signatureStatuses = _a.sent();
                                                        status = signatureStatuses && signatureStatuses.value[0];
                                                        console.log(explorerLinkFor(txid, connection));
                                                        if (!done) {
                                                            if (!status) {
                                                                log.debug('REST null result for', txid, status);
                                                            }
                                                            else if (status.err) {
                                                                log.error('REST error for', txid, status);
                                                                done = true;
                                                                reject(status.err);
                                                            }
                                                            else if (!status.confirmations) {
                                                                log.error('REST no confirmations for', txid, status);
                                                            }
                                                            else {
                                                                log.debug('REST confirmation for', txid, status);
                                                                done = true;
                                                                resolve(status);
                                                            }
                                                        }
                                                        return [3 /*break*/, 3];
                                                    case 2:
                                                        e_1 = _a.sent();
                                                        if (!done) {
                                                            log.error('REST connection error: txid', txid, e_1);
                                                        }
                                                        return [3 /*break*/, 3];
                                                    case 3: return [2 /*return*/];
                                                }
                                            });
                                        }); })();
                                        return [4 /*yield*/, sleep(2000)];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 1];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    // eslint-disable-next-line no-async-promise-executor
                    status = _a.sent();
                    //@ts-ignore
                    if (connection._subscriptionDisposeFunctionsByClientSubscriptionId[subId])
                        connection.removeSignatureListener(subId);
                    done = true;
                    log.debug('Returning status', status);
                    return [2 /*return*/, status];
            }
        });
    });
}
